
import React from 'react';
import { BUSINESS_INFO } from '../constants';
import { ShieldCheck, Lock, Eye, MessageSquare } from 'lucide-react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="bg-transparent min-h-screen py-20 relative overflow-hidden">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="bg-white p-8 md:p-16 rounded-[3rem] shadow-2xl border border-slate-50 reveal-up">
          <div className="flex items-center space-x-4 mb-8">
            <div className="bg-teal-600 p-3 rounded-2xl shadow-lg shadow-teal-600/20">
              <ShieldCheck className="h-8 w-8 text-white" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-slate-900">Privacy Policy</h1>
              <p className="text-sm text-slate-500">Effective Date: {new Date().toLocaleDateString()}</p>
            </div>
          </div>
          
          <div className="prose prose-slate max-w-none text-slate-600 leading-relaxed space-y-10">
            <section>
              <p className="text-lg">
                {BUSINESS_INFO.name} values your privacy and is committed to protecting your personal information. This policy describes how we collect, use, and protect the data you provide to us.
              </p>
            </section>

            <section className="bg-slate-50 p-8 rounded-3xl border border-slate-100">
              <h2 className="text-xl font-bold text-slate-900 mb-6 flex items-center">
                <Eye className="w-5 h-5 mr-3 text-teal-600" /> Information We Collect
              </h2>
              <ul className="grid grid-cols-1 md:grid-cols-2 gap-4 list-none pl-0">
                {['Full Name', 'Email address', 'Phone number', 'WhatsApp messages', 'Contact form data'].map((item, i) => (
                  <li key={i} className="flex items-center space-x-3 bg-white p-4 rounded-xl shadow-sm border border-slate-100">
                    <span className="w-2 h-2 bg-teal-500 rounded-full"></span>
                    <span className="font-medium text-slate-700">{item}</span>
                  </li>
                ))}
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-slate-900 mb-4 flex items-center">
                <Lock className="w-5 h-5 mr-3 text-teal-600" /> How We Use Your Data
              </h2>
              <p className="mb-4">Your information is used exclusively to enhance your experience and provide our services:</p>
              <ul className="space-y-3 list-disc pl-5">
                <li>Respond to inquiries and customer messages accurately.</li>
                <li>Provide dedicated customer support and guidance.</li>
                <li>Communicate regarding our latest wellness products or services.</li>
                <li>Analyze and improve our overall business operations and website performance.</li>
              </ul>
            </section>

            <section className="bg-emerald-50/50 p-8 rounded-3xl border border-emerald-100">
              <h2 className="text-xl font-bold text-slate-900 mb-4 flex items-center">
                <MessageSquare className="w-5 h-5 mr-3 text-emerald-600" /> WhatsApp & Communication
              </h2>
              <p>
                By contacting us via WhatsApp, you consent to receive messages related to your inquiry or our services. We strictly adhere to a no-spam policy and do not send unsolicited marketing messages.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-slate-900 mb-4">Data Protection & Third Parties</h2>
              <p className="mb-4">
                We take reasonable technical and organizational measures to protect personal information. We do not sell, rent, or misuse customer data for third-party profit.
              </p>
              <p className="text-sm italic">
                Note: We use platforms like Meta (Facebook, WhatsApp) for communication. Please review their respective policies as they govern interaction on those platforms.
              </p>
            </section>

            <div className="pt-10 border-t border-slate-100">
              <h3 className="text-lg font-bold text-slate-900 mb-4">Privacy Concerns</h3>
              <p className="text-sm">
                For any data-related questions, reach out to us at:<br />
                <span className="font-bold text-teal-600">{BUSINESS_INFO.email}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
